/* eslint-disable @typescript-eslint/no-unused-vars */
import { Badge, BadgeProps } from '@mui/material';
import { CurrencyImage } from './CurrencyImage';

export type AvatarBadgeProps = BadgeProps<
  'span',
  | { type: 'currency'; currency: string | null | undefined }
  | { type: 'icon'; icon: React.ReactNode | null | undefined }
>;

function renderBadgeContent(props: AvatarBadgeProps) {
  switch (props.type) {
    case 'currency': {
      const { type, currency, ...rest } = props;
      return {
        props: rest,
        content: currency ? <CurrencyImage currency={currency} width="100%" /> : null,
      };
    }
    case 'icon': {
      const { type, icon, ...rest } = props;
      return {
        props: rest,
        content: icon,
      };
    }
    default:
      return { props: {}, content: null };
  }
}

export function AvatarBadge(props: AvatarBadgeProps) {
  const { props: badgeProps, content: badgeContent } = renderBadgeContent(props);

  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent={badgeContent}
      {...badgeProps}
    />
  );
}
